<template>
  <div class="flex flex-column mr-8 md:mr-8">
    <span class="inline-block font-medium text-base mr-2">
      {{ t('dataExplorer.cartFile.cartNumber', [cart.idCart]) }}
    </span>
    <span
      class="font-medium text-500 mt-3 text-sm"
    >
      {{ formatDate(cart.date, 'YYYY-MM-DD HH:mm:ss', 'DD/MM/YYYY HH:mm:ss') }}
    </span>
  </div>
  <div class="mt-2 md:mt-0 ml-0 md:ml-8 flex flex-column align-items-center">
    <span
      class="mb-2 cart-price"
    >
      {{ formatNumberToCurrency(cart.amount, cart.currency) }}
    </span>
    <SpmButton
      :label="t('dataExplorer.contactFile.fields.addresses.openAddressBtn')"
      icon="fa-light fa-circle-info"
      class-style="p-button p-button-secondary"
      @click="openCartFile"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';

import SpmButton from '@/components/spm-primevue/SpmButton.vue';

import { formatDate } from '@/helpers/Date';
import { formatNumberToCurrency } from '@/helpers/Number';

import {
  Cart,
} from '@/types/data-explorer-types';

import { useStore } from '@/store';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'CartItem',

  components: {
    SpmButton,
  },

  props: {
    cart: {
      type: Object as PropType<Cart>,
      required: true,
    },

    keyName: {
      type: String,
      required: true,
    }
  },

  setup (props) {
    const { t } = useI18n();
    const store = useStore();

    const openCartFile = () => {
      store.dispatch('dataExplorer/openCartFile', { idCart: props.cart.idCart, keyName: props.keyName });
    };

    return {
      t,

      formatDate,
      formatNumberToCurrency,
      openCartFile,
    };
  }
})
</script>

<style lang="scss" scoped>
.cart-price {
  color: $brand-color-primary;
  font-size: 1.5rem;
}
</style>